export const PROJECTS = [
  {
    name: "FinAdvisor",
    description:
      "A Python-based agentic AI app using Flask and LangChain for viewing user transactions with insights and recommendations.",
    workedOn: ["Python", "Langchain", "OpenAI", "MongoDB"],
    previewImg: "fin_advisor.png",
    code: "https://github.com/paarshan4800/fin-advisor",
    hosted: null,
  },
  {
    name: "Go-Workers",
    description:
      "A resilient distributed task queue in Go with Redis backend, featuring a configurable goroutine-based worker pool,",
    workedOn: ["Go", "Redis", "Gin"],
    previewImg: "go_worknq.png",
    code: "https://github.com/paarshan4800/go-worknq",
    hosted: null,
  },
  {
    name: "Football Manager",
    description:
      "A desktop application which can be used by football managers to manage their team and the transfer market.",
    workedOn: ["Java AWT", "Swing", "JDBC", "MySQL"],
    previewImg: "football_manager.png",
    code: "https://github.com/paarshan4800/football-manager",
    hosted: null,
  },
  {
    name: "Car Paint Shop API",
    description:
      "A RESTful API for a car painting shop with admin protection, google authentication, two factor authentication and email verification.",
    workedOn: ["Python", "Flask", "PostgreSQL"],
    previewImg: "car_paint_shop.png",
    code: "https://github.com/paarshan4800/car-paint-shop",
    // hosted: "https://car-paint-shop.herokuapp.com/",
  },
  {
    name: "Abacus'21",
    description:
      "Played a major role in the Tech Team in developing the official website using React for the virtual edition of Abacus '21, an intercollege technical symposium.",
    workedOn: ["React", "CSS"],
    previewImg: "abacus_21.png",
    code: "https://github.com/paarshan4800/abacus-21-frontend",
    hosted: null,
  },
  {
    name: "Moviebase",
    description:
      "A web application where users can search and add movies of their choice to their liked list and can also view the most popular movies among other users.",
    workedOn: ["Angular", "Bootstrap", "Django REST"],
    previewImg: "moviebase.png",
    code: "https://github.com/paarshan4800/Moviebase-Django",
    hosted: null,
  },
  {
    name: "Student Attendance Manager",
    description:
      "An Attendance Management System through which students can view their attendance details and faculties can mark and maintain attendance records of students.",
    workedOn: ["Flask", "jQuery", "Bootstrap", "Oracle DB"],
    previewImg: "attendance_manager.png",
    code: "https://github.com/paarshan4800/student-attendance-manager",
    hosted: null,
  },
  // {
  //   name: "Weather.io",
  //   description:
  //     "A responsive Weather Report Web Application which displays daily and hourly weather forecasts of the given location.",
  //   workedOn: ["Angular", "Bootstrap"],
  //   previewImg: "weather_io.png",
  //   code: "https://github.com/paarshan4800/weather-io",
  //   hosted: "https://paarshan4800.github.io/weather-io/weather",
  // },
  {
    name: "Computer Society of Anna University Official Website",
    description:
      "Designed and developed a static website using Angular for the official website of CSAU for the academic year 2020-21 during my tenure as Vice Director.",
    workedOn: ["Angular", "Bootstrap"],
    previewImg: "csau.png",
    hosted: "https://csau.in/",
  },
];
